import { AUTH_TOKEN, DEMO_MODE, DEMO_TOKEN, SESSION_TOKEN, USER_UUID } from "./Constants";
import { setLocalStore, getLocalStore, deleteLocalStore } from "./Helpers";

export function Auth()
{
    const authToken = getLocalStore(AUTH_TOKEN);
    if(!authToken){
        return false
    }

    if(getLocalStore(DEMO_MODE, false, true))
    {
        if(getLocalStore(AUTH_TOKEN) === DEMO_TOKEN)
        {
            return true
        }
        deleteAuth()
        return false
    }

    return true
}

export function setAuth(accessToken, token, uuid)
{
    if(accessToken)
    {
        setLocalStore(AUTH_TOKEN, accessToken)
        setLocalStore(SESSION_TOKEN, token)
        setLocalStore(USER_UUID, uuid)
        setLocalStore(DEMO_MODE, false)
        return
    }

    let authTokenValue = ''
    if(getLocalStore(DEMO_MODE, false, true))
    {
        authTokenValue = DEMO_TOKEN
    }
    setLocalStore(AUTH_TOKEN, authTokenValue)
}

export function getAuthHeaders()
{
    const authToken = getLocalStore(AUTH_TOKEN)
    const sessionToken = authToken ? getLocalStore(SESSION_TOKEN) : null
    const userUuid = authToken ? getLocalStore(USER_UUID) : null

    return {
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
        ...(sessionToken ? { 'X-Admin-Session-Token': sessionToken } : {}),
        ...(userUuid ? { 'X-Admin-User-UUID': userUuid } : {})
    }
}

export function deleteAuth()
{
    deleteLocalStore(AUTH_TOKEN)
    deleteLocalStore(SESSION_TOKEN)
    deleteLocalStore(USER_UUID)
}
